import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Music } from 'lucide-react';
import SafeImg from '@/components/SafeImg';

const SellerCard = ({ seller }) => {
  const getPlatformIcon = (platform) => {
    switch (platform) {
      case 'instagram': return <Instagram size={16} />;
      case 'youtube': return <Youtube size={16} />;
      case 'tiktok': return <Music size={16} />;
      default: return null;
    }
  };

  return (
    <Link
      to={`/seller/${seller.seller_id}`}
      className="group block bg-white dark:bg-[#141414] border border-black/5 dark:border-white/10 rounded-lg overflow-hidden hover:-translate-y-1 hover:shadow-sm transition-all duration-200"
      data-testid="seller-card"
    >
      <div className="aspect-square overflow-hidden bg-gray-100 dark:bg-gray-800">
        <SafeImg
          src={seller.profile_photo}
          kind="seller_profile"
          alt={seller.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between mb-2">
          <h3 className="font-bold text-lg tracking-tight" style={{ fontFamily: 'Manrope, sans-serif' }} data-testid="seller-name">
            {seller.name}
          </h3>
        </div>
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-3 line-clamp-2">{seller.bio}</p>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            {Object.keys(seller.platforms || {}).slice(0, 3).map((platform) => (
              <div key={platform} className="text-gray-500 dark:text-gray-400" data-testid={`platform-${platform}`}>
                {getPlatformIcon(platform)}
              </div>
            ))}
          </div>
          <span className="text-xs text-gray-500 dark:text-gray-400" data-testid="follower-count">
            {seller.follower_count?.toLocaleString()} 팔로워
          </span>
        </div>
      </div>
    </Link>
  );
};

export default SellerCard;
